const convertMmToInches = (value) => value * 0.0393701;
const roundToNearestSixteenth = (value) => Math.round(value * 16) / 16;

const decimalToFraction = (value) => {
    let whole = Math.floor(value);
    let fraction = value - whole;
    let numerator = Math.round(fraction * 16);
    let denominator = 16;

    // reduce fraction
    for (let i = 2; i <= 16; i++) {
        if (numerator % i == 0 && denominator % i == 0) {
            numerator = numerator / i;
            denominator = denominator / i;
            i = 1;
        }
    }

    return { whole, numerator, denominator };
};

export function convertMmToInchesAndFormat(value) {
    value = convertMmToInches(value);

    let roundedValue = roundToNearestSixteenth(value);

    let { whole, numerator, denominator } = decimalToFraction(roundedValue);

    let fraction = '';
    let output = '';
    // hide whole number and - if zero
    if (whole == 0) {
        whole = '';
    }
    //add - to whole number  if denominator is not 0
    if (whole != '' && numerator != 0) {
        whole = whole + '-';
    }
    //hide denominator and numerator if denominator is 0
    if (denominator != 0 && denominator != 1) {
        fraction = numerator + '/' + denominator;
    }
    output = `${whole}${fraction}"`;

    return output;
};

export const updateInchValue = (group, value) => {

    if (!(group instanceof Element)) {
        console.error('The provided "group" is not a DOM element.');
        return;
    }

    let span = group.querySelector('.mm-inch-conversion');
    if (span) {
        span.textContent = value;
    } else {
        appendInchValue(group, value);
    }
}

(function () {

    const appendInchValue = (group, value) => {
        let span = document.createElement('span');
        span.classList.add('input-group-text', 'mm-inch-conversion');
        span.textContent = value;
        group.appendChild(span);
    };

    let mmInputGroups = document.querySelectorAll('.mm-input-group');

    mmInputGroups.forEach(function (group) {

        var value = group.querySelector('input').value;

        if (value === '' || value === '0') {

            let output = '0"';
            appendInchValue(group, output);
            return;
        }

        let output = convertMmToInchesAndFormat(value);
        appendInchValue(group, output);
    });

    document.addEventListener('input', function (event) {
        let target = event.target;
        if (target.tagName === 'INPUT' && target.type === 'number') {
            let group = target.closest('.mm-input-group');
            let value = target.value;
            
            if (value === '' || value === '0') {
                updateInchValue(group, '0"');
                return;
            }

            let output = convertMmToInchesAndFormat(value);
            updateInchValue(group, output);
        }
    });

}
)();


